import axiosRestaurantInstance from '../restaurant/AxiosRestaurantInstance';
import axiosOrganizationInstance from '../organization/AxiosOrganizationInstance';
import axiosGroceryInstance from '../restaurant/AxiosGroceryInstance';
import axiosCustomerInstance from './AxiosCustomerInstance';
import { attachAuthInterceptors } from '../utils/sessionManager';

let configured = false;

export function setupAxiosAuth() {
  if (configured) {
    return;
  }

  [
    axiosRestaurantInstance,
    axiosOrganizationInstance,
    axiosGroceryInstance,
    axiosCustomerInstance,
  ].forEach(attachAuthInterceptors);

  configured = true;
}
